// eslint-disable-next-line
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

export class Secure extends Component {
  static propTypes = {
    hasAll: PropTypes.arrayOf(PropTypes.string),
    hasOne: PropTypes.arrayOf(PropTypes.string),
    notAuthorizedComponent: PropTypes.node,
    permissions: PropTypes.object.isRequired
  }

  render() {
    const { hasOne, hasAll, permissions, children, notAuthorizedComponent } = this.props
    if (
      (hasAll && hasAll.every((required) => permissions.has(required))) ||
      (hasOne && hasOne.some((required) => permissions.has(required)))
    ) {
      return children
    }

    return notAuthorizedComponent || null
  }
}

const mapStateToProps = ({ user }) => ({
  permissions: user.permissions
})

export default connect(mapStateToProps)(Secure)



// WEBPACK FOOTER //
// ./src/containers/Secure.js